export default {"src":"/_next/static/media/learning-task-icon.6cc3b4ff.svg","height":14,"width":14};